import "core-js/modules/es.string.trim";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getBairunSvcRechargeOrderList, exportBairunSvcBalanceOptLogList } from '@/api/bairun/svcRechargeConsumeLog';
import { getStationBaseInfoList } from '@/api/bairun/stationBaseInfo';
import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import SearchTerm from '@/components/searchTerm';
import { mapGetters } from 'vuex';
import { saveAs } from 'file-saver';

var _this;

export default {
  name: 'TicketUseTotal',
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    getStationName: function getStationName(id) {
      for (var i = 0; i < _this.stationOptions.length; i++) {
        if (_this.stationOptions[i].ID === id) {
          return _this.stationOptions[i].stationName;
        }
      }

      return '';
    }
  },
  mixins: [infoList],
  components: {
    SearchTerm: SearchTerm
  },
  computed: _objectSpread({}, mapGetters('stations', ['allStationMap', 'allStations'])),
  data: function data() {
    return {
      listApi: getBairunSvcRechargeOrderList,
      loading: false,
      searchInfo: {
        // 按配置顺序显示
        'ticketRuleNo': '',
        'stationId': ''
      },
      type: '',
      exportVisible: false,
      multipleSelection: [],
      stationOptions: [],
      payChannelOptions: [],
      svcOrderOptTypeOptions: [],
      formData: {
        svcNumber: '',
        startTime: '',
        endTime: ''
      }
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var stationOptions;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return getStationBaseInfoList({
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 2:
                stationOptions = _context3.sent;
                _this3.stationOptions = stationOptions.data.list;

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    onSearch: function onSearch() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (_this4.formData.ticketRuleNo.trim()) {
                  _context4.next = 3;
                  break;
                }

                _this4.$message({
                  type: 'warning',
                  message: '请输入券规则编号'
                });

                return _context4.abrupt("return");

              case 3:
                _this4.page = 1;
                _this4.pageSize = 10;
                _this4.loading = true;
                _context4.next = 8;
                return _this4.getTableData();

              case 8:
                _this4.loading = false;

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    onClose: function onClose() {
      this.exportVisible = false;
      this.formData = {
        svcNumber: '',
        startTime: '',
        endTime: ''
      };
    },
    onExport: function onExport() {
      this.exportVisible = true;
      this.type = 'export';
    },
    doExport: function doExport() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var param, res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                param = {};

                if (_this5.formData.ticketRuleNo.trim()) {
                  _context5.next = 4;
                  break;
                }

                _this5.$message({
                  type: 'warning',
                  message: '请输入券规则编号'
                });

                return _context5.abrupt("return");

              case 4:
                _context5.next = 6;
                return exportBairunSvcBalanceOptLogList(param);

              case 6:
                res = _context5.sent;

                if (res.code === 0) {
                  saveAs(res.data.fileUrl);
                }

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    }
  }
};